import { useNavigate } from "react-router-dom";
import useAddFormData from "../../../../Components/Hooks/useAddFormData";
import { useEffect, useState } from "react";
import * as yup from "yup";
import { useFormik } from "formik";
import {
  BackButton,
  CancelButton,
  SubmitButton,
} from "../../../../Components/Utils/Buttons";

import {
  NuDate,
  NuInput,
  NuMobileNumber,
  NuTextArea,
} from "../../../../Components/Utils/Input";
import axiosInstance from "../../../../Services/axiosCommon";
import UseCustomerDropDownNew from "../../../../Components/Hooks/useCustomerSearch";
import { useToast } from "../../../../Components/Others/ToastServices";
import Attachement from "../../../../Components/Utils/CustomAttrachmentupload";
import FormikSelectTwo, {
  FormikSelectWithAdd,
} from "../../../../Components/Utils/Select";
import useFetchMataData from "../../../../Components/Hooks/useFetchMataData";
import DropDownAddMetaData from "../../../../Components/Utils/selectAddMetaData";
import UseInspectorDD from "../../../../Components/Hooks/useInspectorSearch";
import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
import MultiSelect from "../../../../Components/Utils/MultiSelect";
import UseDropDown from "../../../../Components/Hooks/useDropDown";
import useFetchMetaStar from "../../../../Components/Hooks/useFetchMetaStar";
import { SettingHeading } from "../../../../Components/Utils/Settingheading";

function CreateRenewal() {
  const { value: industry, getData: refindustry } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "industry"
  );

  const navigate = useNavigate();
  const { addFormData, isLoading } = useAddFormData();
  const [searchClient, setSearchClient] = useState("");
  const { data: client, setDataCustomer } = UseCustomerDropDownNew(
    "/clients/drop-down",
    searchClient
  );

  
  const { value: status, getData: refStatus } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "Status_Survey"
  );

  const { data: user } = UseDropDown(`/user/new-drop-down`);

  const [createNew, setCreateNew] = useState({
    contractId: "",
    clientId: "",
    currentEndDate: "",
    proposedEndDate: "",
    currentValue: "",
    proposedValue: "",
    daysToExpire: "",
    status: "",
  });

  const { value: Rating, getData: refRating } = useFetchMetaStar(
    `/dropdown/dropdown-details/`,
    "ratings"
  );

  const [selectedFile, setSelectedFile] = useState(null);
  const [image, setImage] = useState([]);
  const toast = useToast();

   function handleImageChange(e) {
    const maxFileSize = 200000000; // 200 MB
    const files = Array.from(e.target.files);
    let fileArr = [];

    files.forEach((item) => {
      if (item.size < maxFileSize) {  
        fileArr.push(item);
      } else {
        toast.open({
          type: "warning",
          message: `File Size too big`,
          description: `${item.name} is removed and not uploaded`,
        });
      }
    });

    setSelectedFile(fileArr);


    setImage(fileArr);
    e.target.value = null;
  }

  const removeImages = (value) => {
    let List = selectedFile.filter((item) => item?.name !== value?.name);
    setSelectedFile([...List]);
    setImage(List);
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
      clientId: yup.string().required("Client is required!"),
        }),
    onSubmit: async (value, { resetForm }) => {
      let formData = new FormData();
      formData.append("json_data", JSON.stringify(value));
      if (selectedFile !== null) {
        selectedFile.forEach((file) => {
          formData.append("attachments", file);
        });
      } else {
        formData.append("attachments", []);
      }
      await addFormData({
        url: `/renewals/new-renewal`,
        formData: formData,
        navigateUrl: `/Contract-management/renewal`,
        resetForm: resetForm,
      });
    },
  });

 
  const [showPopup, setShowPopup] = useState(false);

  const togglePopup = () => {
    setShowPopup(!showPopup);
  };

  const resetForm = () => {
    //  formik.values.type = ""
    formik.values.companyName = "";
    formik.values.email = "";
    formik.values.industry = "";
    formik.values.pcName = "";
    formik.values.pcDesignation = "";
    formik.values.pcCountryCode = "";
    formik.values.pcMobile = "";
    formik.values.phoneCC = "";
    formik.values.phone = "";
    formik.values.ratings = "";

    setShowPopup(false);
  };
  const { value: designation, getData: refdesignation } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "desigination"
  );
  const handlePopupSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append(
      "json_data",
      JSON.stringify({
        companyName: formik.values.companyName || "",
        email: formik.values.email || "",
        industry: formik.values.industry || "",
        category: formik.values.category || "",
        pcName: formik.values.pcName || "",
        pcDesignation: formik.values.pcDesignation || "",
        pcCountryCode: formik.values.pcCountryCode || "",
        pcMobile: formik.values.pcMobile || "",
        phone: formik.values.phone || "",
        phoneCC: formik.values.phoneCC || "",
        ratings: formik.values.ratings || "",
      })
    );
    try {
      const response = await axiosInstance.post(
        "/clients/new-client",
        formData
      );
      const createdAgent = response.data?.data;

      setDataCustomer((prevCustomers) => [
        {
          label: formik.values.companyName || "-",
          value: createdAgent,
        },
        ...prevCustomers,
      ]);
      resetForm();
    } catch (error) {
      console.error("Error creating new customer:", error);
    }
  };

  const { data: contract } = UseDropDown(`/contract/drop-down`);

   const [Newclient, setclient] = useState([]);

  function getContractsByClientId(clientId) {
    axiosInstance
      .get(`/contract/drop-down/client/${clientId}`)
      .then((res) => {
       if (Array.isArray(res.data)) {
        const formatted = res.data.map(item => ({
          value: item.id,        
          label: item.name      
        }));
        setclient(formatted);
        } else {
          console.error("Unexpected API response format");
          setclient([]);
        }
      })
      .catch(err => {
        console.error("Error fetching contracts by client ID:", err);
        setclient([]);
      });
  }

  useEffect(() => {
  if (formik.values.clientId) {
    getContractsByClientId(formik.values.clientId);
  }
  }, [formik.values.clientId])

  return (
    <div className=" w-full h-full py-2 px-4 ">
      <div className="flex justify-between w-full">
        <Breadcrumb
          items={[
            {
              name: "Renewal",
              link: "/Contract-management/renewal",
            },

            { name: "Create" },
          ]}
        />
        <BackButton />
      </div>
      <form onSubmit={formik.handleSubmit}>
        <div className="w-full mx-auto h-[calc(100vh-145px)] bg-white rounded-xl overflow-hidden mt-4">
          <div className=" w-full h-full flex justify-start content-start flex-wrap py-2 px-4  overflow-y-auto">
            <div className="w-full">
              <SettingHeading title="Renewal" />
            </div>
            <FormikSelectTwo
              type="text"
              label="Client"
              placeholder="Client"
              Options={client}
              formik={formik}
              name="clientId"
              isRequired={true}
              width="w-full md:w-1/3 "
              // handleClick={togglePopup}
              FixPosition={false}
              PortalTarget={true}
              setSearch={setSearchClient}
            />

            <FormikSelectTwo
              label="Contract "
              Options={Newclient}
              formik={formik}
              placeholder="Choose"
              name="contractId"
              isRequired={true}
              width="w-full md:w-1/3 lg:w-1/3"
            />

            <NuDate
              label="Current End Date"
              placeholder="Current End Date"
              formik={formik}
              name="currentEndDate"
              width="w-full md:w-1/3 md:-mt-2"
            />
            <NuDate
              label="Proposed End Date"
              placeholder="Proposed End Date"
              formik={formik}
              name="proposedEndDate"
              width="w-full md:w-1/3 md:-mt-2"
               min={new Date().toISOString().split("T")[0]} 
            />

            {/* <NuInput
              type="text"
              label="Days to Expire"
              placeholder="Days to Expire"
              formik={formik}
              name="daysToExpire"
              width="w-full md:w-1/3 md:-mt-2"
            /> */}

            <NuInput
              type="text"
              label="Current Value"
              placeholder="Current Value"
              formik={formik}
              name="currentValue"
              width="w-full md:w-1/3 md:-mt-2"
            />

            <NuInput
              type="text"
              label="Proposed Value"
              placeholder="Proposed Value"
              formik={formik}
              name="proposedValue"
              width="w-full md:w-1/3 md:-mt-2"
            />

            {/* <MultiSelect
              label="Assignee"
              Options={user}
              formik={formik}
              placeholder="Choose"
              name="assignee"
              isRequired={true}
              width="w-full md:w-1/3 md:-mt-2"
            />
            <NuInput
              type="text"
              label="Location"
              placeholder="Location"
              formik={formik}
              name="location"
              width="w-full md:w-1/3 md:-mt-2"
            /> */}

            {/* <NuTextArea
              type="text"
              label="Scope of Work"
              placeholder="Scope of Work"
              formik={formik}
              name="scope"
              width="w-full md:w-1/2 md:-mt-2"
            /> */}

            {/* <DropDownAddMetaData
              type="text"
              label="Status"
              placeholder="Status"
              Options={status}
              formik={formik}
              name="status"
              width="w-full md:w-1/3 lg:w-1/3 md:-mt-3"
              displayProperty={"Status"}
              propertyName={"Status_Survey"}
              getFunc={refStatus}
            /> */}

            <div className="w-full">
              <SettingHeading title="Attchment " />
            </div>
            <Attachement
              handleChange={handleImageChange}
              preview={image || ""}
              width="w-full"
              label="Attach"
              multiple={true}
              removeImages={removeImages}
            />

            <div className="w-full  my-4 mt-8 ">
              <div className=" flex justify-end gap-4">
                <CancelButton
                  handleClick={() => {
                    navigate(-1);
                  }}
                />
                <SubmitButton isLoading={isLoading} />
              </div>
            </div>
          </div>
        </div>
      </form>

      {showPopup && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
          <div className="animate-scale-in w-[80%] md:w-[60%] max-h-[80vh] bg-white py-2 px-4 rounded-md shadow-lg overflow-y-scroll ">
            <h2 className="text-lg font-normal text-[12px]">Add Client</h2>
            <form onSubmit={handlePopupSubmit}>
              <div className="mb-4 flex flex-wrap">
                <NuInput
                  type="text"
                  label="Company "
                  placeholder="Company "
                  formik={formik}
                  name="companyName"
                  width="w-full md:w-1/2 lg:w-1/2"
                  isRequired={true}
                />

                <NuInput
                  type="email"
                  label="Email"
                  placeholder="Email"
                  formik={formik}
                  name="email"
                  width="w-full md:w-1/2 lg:w-1/2"
                  // isRequired={true}
                />
                <NuMobileNumber
                  nunCode="countryCode"
                  label="Phone"
                  placeholder="Phone"
                  formik={formik}
                  name="phone"
                  // isRequired={true}
                  FixPosition={true}
                  PortalTarget={false}
                  width="w-full md:w-1/2 lg:w-1/2"
                />
                <DropDownAddMetaData
                  type="text"
                  label="Industry"
                  placeholder="Industry"
                  Options={industry}
                  formik={formik}
                  name="industry"
                  width="w-full md:w-1/2 lg:w-1/2"
                  displayProperty={"Industry"}
                  propertyName={"industry"}
                  getFunc={refindustry}
                  FixPosition={true}
                  PortalTarget={false}
                />

                <FormikSelectTwo
                  Options={Rating}
                  label=" Ratings"
                  placeholder=" Ratings"
                  formik={formik}
                  name="ratings"
                  width="w-full md:w-1/2 lg:w-1/3"
                />
                <div className="w-full">
                  <p className="pb-2 pt-4 px-4 text-sm font-medium text-[#111537] underline decoration-textColor-main decoration-2 underline-offset-4">
                    Primary Contact :
                  </p>
                </div>
                <NuInput
                  type="text"
                  label="Contact Person "
                  placeholder="Contact Person "
                  formik={formik}
                  name="pcName"
                  // isRequired={true}
                  width="w-full md:w-1/2 lg:w-1/2"
                />

                <DropDownAddMetaData
                  type="text"
                  label="Designation"
                  placeholder="Designation"
                  Options={designation}
                  formik={formik}
                  name="pcDesignation"
                  width="w-full md:w-1/2 lg:w-1/2 md:-mt-1"
                  // isRequired={true}
                  displayProperty={"Designation"}
                  propertyName={"Designation_Client"}
                  getFunc={refdesignation}
                  FixPosition={true}
                  PortalTarget={false}
                />

                <NuMobileNumber
                  nunCode="pcCountryCode"
                  label="Phone"
                  placeholder="Phone"
                  formik={formik}
                  name="pcMobile"
                  // isRequired={true}
                  FixPosition={true}
                  PortalTarget={false}
                  width="w-full md:w-1/2 lg:w-1/2"
                />

                <NuInput
                  type="email"
                  label="Email"
                  placeholder="Email"
                  formik={formik}
                  name="pcEmail"
                  // isRequired={true}
                  width="w-full md:w-1/2 lg:w-1/2"
                />
              </div>
              <div className="flex justify-end">
                <button
                  type="button"
                  onClick={togglePopup}
                  className="px-5 py-[9px] cursor-pointer text-xs 2xl:text-sm bg-[#E6F2F2]  hover:bg-gray-300
                  rounded-md flex items-center mr-2 text-textColor-main"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="bg-textColor-main px-5 py-[9px] cursor-pointer outline-none border-none text-white rounded-md text-xs 2xl:text-sm flex items-center"
                >
                  Add
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default CreateRenewal;
